import messages from './messages.graphql';
import createMessage from './createMessage.graphql';
import updateMessage from './updateMessage.graphql';
import deleteMessage from './deleteMessage.graphql';

export const messagesQuery = messages;
export const createMessageMutation = createMessage;
export const updateMessageMutation = updateMessage;
export const deleteMessageMutation = deleteMessage;
